import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import ClassAssignmentForm from "../ClassAssignmentForm/ClassAssignmentForm";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import AddAssignment from "../AddAssignment/AddAssignment";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import AssignmentBody from "../AssignmentBody/AssignmentBody";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewAssignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      data: {
        session: new Date().getFullYear(),
        class: "",
        faculty: "",
        group: "",
        section: "",
      },
      column: [
        {
          name: "S.N",
        },
        { name: "Title" },
        { name: "Assignment Files" },
        { name: "Subject" },
        { name: "Deadline" },
        { name: "Actions" },
      ],
      assignments: [],
      detailStatus: false,
      subjects: [],
      loading: false,
    };
  }

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        class: e.target.value,
        faculty: "",
        group: "",
        section: "",
      },
    });
  };

  getAssignments = async () => {
    const response = await Axios.get(`${url}/api/assignments`, {
      params: {
        studentClass: this.state.data.class,
        faculty: this.state.data.faculty ? this.state.data.faculty : "",
        group: this.state.data.group ? this.state.data.group : "",
        section: this.state.data.section,
      },
      headers: {
        Authorization: `Bearer ${this.props.adminToken}`,
      },
    });
    if (response.data.assignments.length !== 0) {
      this.setState({
        assignments: response.data.assignments,
      });
    }
  };

  handleSubmit = async (e, subjects) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      if (subjects.length !== 0) {
        this.getAssignments();
        this.setState({
          detailStatus: true,
          subjects,
          loading: false,
        });
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  render() {
    const { rowsPerPage, page } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Assignments" refreshUrl={this.props.match.url} />
          <ClassAssignmentForm
            loading={this.state.loading}
            buttonLabel="Set Assignments"
            data={this.state.data}
            handleChangeClass={this.handleChangeClass}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
          {this.state.detailStatus && (
            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />

                <TableBody>
                  <AddAssignment
                    config={this.state.data}
                    subjects={this.state.subjects}
                    getAssignments={this.getAssignments}
                  />
                  {this.state.assignments.length !== 0 &&
                    this.state.assignments.map((assignment, index) => (
                      <AssignmentBody
                        key={index}
                        index={index}
                        data={assignment}
                        getAssignments={this.getAssignments}
                      />
                    ))}
                </TableBody>

                <CustomTableFooter
                  count={this.state.assignments.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handlePage}
                  onChangeRowsPerPage={this.handleRowsPerPage}
                />
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewAssignment)));
